import { createFileRoute, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { InvitationsPage } from "src/pages/InvitationsPage";

export const Route = createFileRoute("/_auth/invitations/")({
  component: InvitationsPage,
  loader: async () => {
    return loaderHandler(async ({ trpc, session }) => {
      const invitations = await trpc.invitation.listInvitations.query();

      if (session?.coach) {
        return {
          data: {
            type: "coach" as const,
            invitations: invitations,
          },
        };
      } else if (session?.athlete) {
        return {
          data: {
            type: "athlete" as const,
            invitations: invitations,
          },
        };
      }

      throw redirect({ to: "/" });
    });
  },
  staticData: {
    getBreadcrumb() {
      return {
        labelTranslationKey: "invitations",
        href: "/invitations",
      };
    },
  },
});
